import React from "react";
import { Phone } from "lucide-react";
import { GemMark, scrollToId } from "./Reveal";

export default function Footer() {
    return (
        <footer data-testid="footer" className="border-t border-gold/15 bg-obsidian py-14">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col md:flex-row items-center md:justify-between gap-8 text-center md:text-left">
                <button onClick={() => scrollToId("hero")} data-testid="footer-logo" className="flex flex-col items-center md:flex-row gap-3 group">
                    <GemMark size={30} />
                    <span className="font-display text-xl text-ivory group-hover:text-gold-light transition-colors">
                        Maa Gayatri Jewellers
                    </span>
                </button>
                <p className="text-muted text-xs tracking-wide leading-relaxed">
                    Jadia, Thana Road, Supaul District, Bihar
                    <br className="md:hidden" />
                    <span className="md:ml-3">Gold · Silver · Diamond · Imitation</span>
                </p>
                <a
                    href="tel:7209661797"
                    data-testid="footer-call-button"
                    className="inline-flex items-center gap-2 text-gold-light text-sm font-semibold border border-gold/40 hover:border-gold-light px-5 py-2.5 transition-all duration-300"
                >
                    <Phone size={13} />
                    7209661797
                </a>
            </div>
            <p className="text-center text-[11px] text-muted/70 mt-10 tracking-[0.2em] uppercase">
                © Maa Gayatri Jewellers — Kunal Diwakar · Trust · Purity · Tradition
            </p>
        </footer>
    );
}
